import React from "react";
const ThankYouPage = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg w-1/2">
        <h1 className="text-4xl font-bold mb-6 text-center">Thank You!</h1>
        <p className="text-xl text-center">
          Thank you for submitting your response. Your application is currently
          under review. We will notify you via message and email provided by
          you.
        </p>
      </div>
    </div>
  );
};

export default ThankYouPage;
